import * as React from 'react';
import { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { getSurveyPreviewAsync } from '../../ajax/requests';
import { SurveyTokenData } from '../../shared/surveys';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import {
    CenterState,
    CenterStateInner,
    LoadingText,
    Page,
    PageShell,
    SurveyFormView,
} from '../SurveyResponse/SurveyFormView';
import { BannerAlert } from '../SurveyResponse/SurveyFormView.styles';

const SurveyPreview: React.FC = () => {
    const t = useTranslations();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [tokenData, setTokenData] = useState<SurveyTokenData | null>(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('id');

        if (!id) {
            setError(t(TK.somethingWentWrong));
            setLoading(false);
            return;
        }

        getSurveyPreviewAsync(id)
            .then((data: SurveyTokenData) => {
                setTokenData(data);
                setLoading(false);
            })
            .catch(() => {
                setError(t(TK.somethingWentWrong));
                setLoading(false);
            });
    }, [location.search]); // eslint-disable-line react-hooks/exhaustive-deps

    if (loading) {
        return (
            <Page>
                <PageShell>
                    <CenterState>
                        <CenterStateInner>
                            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                            <LoadingText>{t(TK.loading)}...</LoadingText>
                        </CenterStateInner>
                    </CenterState>
                </PageShell>
            </Page>
        );
    }

    if (error || !tokenData) {
        return (
            <Page>
                <PageShell>
                    <CenterState>
                        <CenterStateInner>
                            <BannerAlert color="danger">
                                <h4>{t(TK.error)}</h4>
                                <p>{error ?? t(TK.somethingWentWrong)}</p>
                            </BannerAlert>
                        </CenterStateInner>
                    </CenterState>
                </PageShell>
            </Page>
        );
    }

    // token is intentionally omitted → SurveyFormView enters preview mode
    return <SurveyFormView tokenData={tokenData} />;
};

export default SurveyPreview;
